import axios from "axios";
import { DEFAULT_ENV } from "../constants";

const paulDomains = {
  public: {
    development: "https://publicapi.insurgate.test",
    staging: "https://publicapi.insurgate-staging.com",
    validation: "https://publicapi.insurgate-validation.com",
    production: "https://publicapi.insurgate.be",
  },
  private: {
    development: "https://paul.insurgate.test/api",
    staging: "https://paul.insurgate-staging.com/api",
    validation: "https://paul.insurgate-validation.com/api",
    production: "https://paul.insurgate.be/api",
  },
};

class PaulService {
  constructor(envrionment = DEFAULT_ENV, publicApi = true, token) {
    this.publicApi = publicApi;
    this.axiosInstance = axios.create({
      baseURL: publicApi
        ? paulDomains.public[envrionment]
        : paulDomains.private[envrionment],
      headers: {
        Token: token,
        "x-version": "1.0.0",
      },
    });
  }

  setEnvironment = (env) => {
    this.axiosInstance.defaults.baseURL =
      paulDomains[this.publicApi ? "public" : "private"][env];
  };

  createCR = async (env, userId, productId, data, invisible) => {
    this.setEnvironment(env);
    return new Promise((resolve, reject) => {
      this.axiosInstance
        .post("/requests", {
          request: {
            user_id: userId,
            product_id: productId,
            data,
            invisible,
          },
        })
        .then((response) => {
          resolve(response.data.request);
        });
    });
  };

  createRequestUserToken = async (env, userId, requestId) => {
    this.setEnvironment(env);
    return new Promise((resolve, reject) => {
      this.axiosInstance
        .post("/request-user-tokens", {
          token: {
            user_id: userId,
            request_id: requestId,
          },
        })
        .then((response) => {
          resolve(response.data.token);
        });
    });
  };
}

export default PaulService;
